exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".runs-bullet {\n  margin: 0 6px; }\n\n.run-name-link.bolt-table-link {\n  padding: 0; }\n", ""]);

// exports
